export default "__VITE_ASSET__D6egR2Ky__"